/* 
 * for input[type=number] elements, converts all commas to dots when parsing value into model.
 * useful for when users browser locale is one that uses commas to represent decimal points (e.g. german).
 */

import {default as app} from '@legacy/App';

 
app.directive('input', [function () {
    return {
        restrict: 'E',
        require: ['?ngModel'],
        priority: 0,
        link: {
            pre: function (scope, element, attrs, controller) {
                var ctrl = controller[0];
                    if (ctrl && attrs.type.toLowerCase() === 'number') {
                    ctrl.$parsers.unshift(function (value) {
                        if (angular.isString(value)) return value.replace(/,/g, '.');
                        return value;
                    });
                }
            }
        }
    };
}]);